import React from 'react'
import DisplayFormatedNumber from '../../../../../components/DisplayFormatedNumber'
import { usePayoutPopupContext } from '../context'

const AnnualPayoutSummary = () => {
  const { data } = usePayoutPopupContext()

  if (!data) {
    return null
  }

  const teamBonusRelatedAmount = (
    <DisplayFormatedNumber value={data.annualPayout?.teamBonus?.teamBonusRelatedAmount ?? 0} format="euroInt" />
  )
  const annualTeamBonusPayout = (
    <DisplayFormatedNumber value={data.annualPayout?.teamBonus?.annualTeamBonusPayout ?? 0} format="euroInt" />
  )

  const teamBonusRate = (data.annualPayout?.teamBonus?.teamBonusRate ?? 0) / 100

  return (
    <>
      ({teamBonusRelatedAmount} x {teamBonusRate}) = {annualTeamBonusPayout}
    </>
  )
}

export default AnnualPayoutSummary
